import React, { useEffect, useState } from 'react';
import { concatClassNames } from '../../../../utils/utilities';
import { error } from '../../../../services/toastService';

import Conditional from '../../../common/conditional';
import classNames from './style.module.scss';

interface AccordionItemProps {
	isOpenOnDefault?: boolean;
	isActive: boolean;
	title: string;
	children: React.ReactNode | React.ReactNode[];
}

const AccordionItem: React.FC<AccordionItemProps> = ({
	children,
	isOpenOnDefault = false,
	isActive,
	title,
}) => {
	const [isOpen, setOpen] = useState(false);

	const handleOpenToggle = () => {
		if (isActive) return setOpen((prev) => !prev);

		error('This section is disabled until you complete the previous section!');
	};

	const isAllowedToToggle = isActive && isOpen;

	useEffect(() => {
		if (isOpenOnDefault) setOpen(isOpenOnDefault)
	}, [isOpenOnDefault]);

	return (
		<div className={classNames.accordionItem}>
			<div
				onClick={handleOpenToggle}
				role="button"
				className={concatClassNames([classNames.accordionItemHeader, isActive ? classNames.accordionItemHeaderActive : ''])}
			>
				<div>{title}</div>
				<i className={`bi bi-chevron-${isAllowedToToggle ? 'down' : 'right'}`}></i>
			</div>

			<Conditional isVisible={isAllowedToToggle}>
				<div className={classNames.accordionItemBody}>{children}</div>
			</Conditional>
		</div>
	);
};

export default AccordionItem;
